declare var window:any

const Backbone = require('backbone')
const _ = require('underscore')
import { sobrescreverInformacoesAction } from 'app/redux/orcamentoSlice'
import store from 'app/redux/store/store'
import global from 'globalMU'
import { substituirItemEmArray } from 'substituirItemEmArray'
import {atualizarItemAction as atualizarItemAction} from 'app/redux/orcamentoSlice'
import * as R from 'ramda'


const ItemOrcamento = Backbone.Model.extend({
    name: "ItemOrcamento",

    initialize: function(model, options) {
        const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros['ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL']

        this.iniciarEventos();
        this.set("Atualizar", false);
        this.set("AtualizarVendaSobEncomenda", false);
        this.set("AtualizarRemoto", true);
        this.set("CodigoTipoEntregaAnterior", this.get("CodigoTipoEntrega"));
        this.set("QuantidadeAnterior", this.get("Quantidade"));
        this.set("CodigoFilialRetiradaAnterior", this.get("CodigoFilialRetirada"));
        this.set("OcultarRetiradaOutroLocal", store.getState().orcamento?.TipoOrcamentoDescricao == "Outras Saídas" && valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL !== "S");
        this.set("DescricaoTipoOrcamento", store.getState().orcamento.TipoOrcamento === 1  ?
                                            "Outras Saídas":
                                            store.getState().orcamento.TipoOrcamento === 2 ?
                                                "Transferências" :
                                                "Venda");
        this.set("TipoOrcamento", store.getState().orcamento.TipoOrcamento);
        this.set("SimulandoDesconto", false);
        this.set('CorAmbiente',R.tryCatch(() => store.getState().corPorAmbiente[model.Ambiente], R.always(null)) ())

        // var dataMarcadaInserida = this.get("DataMarcadaEntrega");

        // const possuiDataMarcadaEntrega = dataMarcadaInserida && global.validateDate(dataMarcadaInserida)
        this.set("PossuiDataMarcadaEntrega", model.DataMarcadaEntrega != null ? true : null)
        // store.dispatch(atualizarItemAction({
        //     identificador: this.get("Identificador"),
        //     dados: {
        //         PossuiDataMarcadaEntrega: possuiDataMarcadaEntrega
        //     }
        // }))

        

        if (options.orcamento) {
            this.orcamento = options.orcamento;
        }
        $("input").on('focus', function () { $(this).select(); });
    },

    iniciarEventos: function () {
        this.on("change:OrdemItem", this.ordemItemAlterada, this);
        this.on("change:DescricaoProduto", this.descricaoProdutoAlterada, this);
        this.on("change:Quantidade", this.quantidadeAlterada, this);
        this.on("change:PrecoProduto", this.precoProdutoAlterado, this);
        this.on("change:percentualMarkUp", this.markUpItemAlterado, this);
        this.on("change:DespesasInclusas", this.despesasInclusasAlterado, this);
        this.on("change:OfertaSelecionada", this.OfertaSeletivaAlterada, this);
        this.on("change:CodigoTipoEntrega", this.tipoEntregaAlterado, this);
        this.on("change:DataPrevisaoEntrega", this.dataPrevisaoEntregaAlterada, this);
        this.on("change:DataMarcadaEntrega", this.dataMarcadaEntregaAlterada, this);
        this.on("change:TurnoEntrega", this.turnoEntregaAlterado, this);
        this.on("change:Ambiente", this.ambienteAlterado, this);
        this.on("change:EntregaPosterior", this.entregaPosteriorAlterado, this);
        this.on("change:VendaSobEncomenda", this.vendaSobEncomendaAlterado, this);
        this.on("change:IdClienteCentroCusto", this.idClienteCentroCustoAlterado, this); // FNX-4253
        this.on("change:CodigoFilialRetirada", this.filialRetiradaAlterado, this);
        this.on("change:CodigoFilialTransferencia", this.filialTransferenciaAlterado, this);
        this.on("change:TipoFaturamento", this.tipoFaturamentoAlterado, this);
        this.on("change:PedidoCompraCliente", this.adicionaPedidoCompraCliente, this);
        this.on("change:AliquotaIPI", this.aliquotaIPIAlterada, this);
        this.on("change:ValorIPI", this.valorIPIAlterado, this);
        this.on("change:PercentualBonificacao", this.bonificacaoProdutoAlterado, this);
        this.on("change:PedidoCompra", this.pedidoCompraAlterado, this);
        this.on("change:DesativaRegimeEspecial", this.desativaRegimeEspecialAlterado, this);
    },

    alterarItem: function(data, callback) {

        var self = this;

        var jsonData = this.toJSON();

        jsonData.Quantidade = data.Quantidade;
        jsonData.DespesasInclusas = data.DespesasInclusas === "on";
        jsonData.CodigoTipoEntrega = data.CodigoTipoEntrega;
        jsonData.DataPrevisaoEntrega = data.DataPrevisaoEntrega;
        jsonData.DataMarcadaEntrega = data.DataMarcadaEntrega;
        jsonData.TurnoEntrega = data.TurnoEntrega;

        global.ajax({
            url: "/Orcamento/EditarItem",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                item: jsonData
            }),
            success: function(data) {

                var error = false;

                if (data) {

                    self.off("change:Quantidade");
                    self.set("Quantidade", data.Quantidade);
                    self.on("change:Quantidade", self.quantidadeAlterada, self);

                    self.off("change:DespesasInclusas");
                    self.set("DespesasInclusas", data.DespesasInclusas);
                    self.on("change:DespesasInclusas", self.itemAlterado, self);

                    self.off("change:CodigoTipoEntrega");
                    self.set("DescricaoTipoEntrega", data.DescricaoTipoEntrega);
                    self.set("CodigoTipoEntrega", data.CodigoTipoEntrega);
                    self.on("change:CodigoTipoEntrega", self.itemAlterado, self);

                    self.set("DataPrevisaoEntrega", data.DataPrevisaoEntrega);
                    self.set("DataMarcadaEntrega", data.DataMarcadaEntrega);
                    self.set("TurnoEntrega", data.TurnoEntrega);

                    if (data.IdentificadorErro) {
                        error = true;
                        global.showErrorMessage(data.IdentificadorErro);
                    }

                    self.set("ValorTotal", data.ValorTotal);
                }

                if (self.orcamento) {
                    self.orcamento.atualizarTotaisOrcamento();
                }

                if (!error && callback) {
                    callback();
                }
            },
        });
    },

    itemAlterado: function() {

        var self = this;

        global.ajax({
            url: "/Orcamento/EditarItem",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                item: this.toJSON()
            }),
            success: function(data) {

                if (data) {

                    if (data.IdentificadorErro) {

                        self.off("change:Quantidade");
                        self.set("Quantidade", data.Quantidade);
                        self.on("change:Quantidade", self.quantidadeAlterada, self);

                        self.off("change:DespesasInclusas");
                        self.set("DespesasInclusas", data.DespesasInclusas);
                        self.on("change:DespesasInclusas", self.itemAlterado, self);

                        self.off("change:CodigoTipoEntrega");
                        self.set("CodigoTipoEntrega", data.CodigoTipoEntrega);
                        self.on("change:CodigoTipoEntrega", self.itemAlterado, self);

                        self.set("DescricaoTipoEntrega", data.DescricaoTipoEntrega);

                        self.set("PrecoAlteradoManualmente", data.PrecoAlteradoManualmente);

                        global.showErrorMessage(data.IdentificadorErro);
                    }

                    self.set("ValorTotal", data.ValorTotal);
                }

                if (self.orcamento) {
                    self.orcamento.atualizarTotaisOrcamento();
                }
            },
        });
    },

    excluir: function() {

        var excluido = false;

        global.ajax({
            url: "/Orcamento/ExcluirItem",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                item: this.toJSON()
            }),
            async: false,
            success: function(data) {

                data = global.tratarRetorno(data);

                if (data) {
                    excluido = true;
                }
            }
        });

        return excluido;

    },

    ambienteAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/EditarAmbienteItem",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificadorItem: this.get("Identificador"),
                ambiente: this.get("Ambiente")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

            }
        });

    },

    atualizar: function(data, ehParaAtualizarEstadoLegado = true, ehParaAtualizarRedux = true, silent = false) {

        if (ehParaAtualizarEstadoLegado == false) {
            console.warn('itemOrcamento.atualizar chamado com ehParaAtualizarEstadoLegado = false. atualizacao tardia do estado legado foi descontinuada, agora o estado do redux e do legado sempre sao atualizados')
            ehParaAtualizarEstadoLegado = true
        }

        const atualizarEstadoLegado = () => {
            const setOptions = {silent}

            this.set("AtualizarRemoto", false);
            this.set("DescricaoProduto", data.DescricaoProduto,setOptions);
            this.set("Quantidade", data.Quantidade,setOptions);
            this.set("QuantidadeEstoque", data.QuantidadeEstoque,setOptions);
            this.set("QuantidadeFaltante", data.QuantidadeFaltante,setOptions);
            this.set("DescricaoTipoEntrega", data.DescricaoTipoEntrega,setOptions);
            this.set("CodigoTipoEntrega", data.CodigoTipoEntrega,setOptions);
            this.set("DataMarcadaEntrega", data.DataMarcadaEntrega,setOptions);
            this.set("DataPrevisaoEntrega", data.DataPrevisaoEntrega,setOptions);
            this.set("TurnoEntrega", data.TurnoEntrega,setOptions);
            this.set("DescricaoTurnoEntrega", data.DescricaoTurnoEntrega,setOptions);
            this.set("EntregaPosterior", data.EntregaPosterior,setOptions);
            
            this.set("VendaSobEncomendaAnterior", this.get("VendaSobEncomenda"),setOptions);

            this.set("VendaSobEncomenda", data.VendaSobEncomenda,setOptions);
            this.set("TipoVendaSobEncomenda", data.TipoVendaSobEncomenda,setOptions);
            this.set("CodigoFilialRetirada", data.CodigoFilialRetirada,setOptions);
            this.set("CodigoFilialTransferencia", data.CodigoFilialTransferencia,setOptions);
            this.set("TipoFaturamento", data.TipoFaturamento,setOptions);
            this.set("DescricaoTipoFaturamento", data.DescricaoTipoFaturamento,setOptions);
            this.set("CodigoTipoFaturamento", data.CodigoTipoFaturamento,setOptions);
            this.set("AdquirirQuantidadeTotal", data.AdquirirQuantidadeTotal,setOptions);
            this.set("ProdutoEncomendaComprarTotal", data.ProdutoEncomendaComprarTotal,setOptions); // 416558
            this.set("PedidoVendaCliente", data.PedidoVendaCliente,setOptions);
            this.set("PedidoCompraCliente", data.PedidoCompraCliente,setOptions);
            this.set("AliquotaIPI", data.AliquotaIPI,setOptions);
            this.set("ValorIPI", data.ValorIPI,setOptions);
            this.set("PrecoProduto", data.PrecoProduto,setOptions);
            this.set("PrecoTinta", data.PrecoTinta,setOptions);
            this.set("ValorSubstituicao", data.ValorSubstituicao,setOptions);
            this.set("PercentualMaximoDesconto", data.PercentualMaximoDesconto,setOptions);
            
            this.set("PercentualDesconto", global.formatNumber(data.PercentualDesconto),setOptions);

            this.set("PrecoAlteradoManualmente", data.PrecoAlteradoManualmente,setOptions);
            this.set("DescontoPendente", data.DescontoPendente,setOptions);
            this.set("BonificacaoPendente", data.BonificacaoPendente,setOptions);
            this.set("PrecoUnitarioTabela", data.PrecoUnitarioTabela,setOptions);
            //this.set("EstoqueProdutoDisponivel", data.EstoqueProdutoDisponivel);
            this.set("BloqueadoEstoque", data.BloqueadoEstoque,setOptions);
            this.set("EncomendaAutomatica", data.EncomendaAutomatica,setOptions);
            this.set("ControleLote", data.ControleLote,setOptions);
            this.set("Cor", data.Cor,setOptions);
            this.set("PercentualBonificacao", data.PercentualBonificacao,setOptions);
            this.set("IdClienteCentroCusto", data.IdClienteCentroCusto,setOptions);  // FNX-4253
            this.set("NomeCentroCusto", data.NomeCentroCusto,setOptions); // FNX-4253
            this.set("PercentualMarkUp", data.PercentualMarkUp,setOptions);
            this.set("MarkUpAbaixoDoPermitido", data.MarkUpAbaixoDoPermitido,setOptions);
            this.set("PedidoCompra", data.PedidoCompra,setOptions);
            this.set("DesativaRegimeEspecial", data.DesativaRegimeEspecial,setOptions);
            this.set("BloquearRegimeEspecial", data.BloquearRegimeEspecial,setOptions);
            this.set("DesativaRegimeEspecialAntes", data.DesativaRegimeEspecialAntes,setOptions);
            this.set("PendenciaDescontoSobreOferta", data.PendenciaDescontoSobreOferta,setOptions); //FNX-5360
            this.set('PreservaDesconto', data.PreservaDesconto, setOptions)
            this.set('PrioridadeMontagem', data.PrioridadeMontagem, setOptions) // 456839
            

            if (data.VendaSobEncomenda &&
                (this.get("CodigoTipoEntregaAnterior") !== data.CodigoTipoEntrega ||
                    this.get("CodigoFilialRetiradaAnterior") !== data.CodigoFilialRetirada ||
                    this.get("QuantidadeAnterior") !== data.Quantidade)) {

                this.set("AtualizarVendaSobEncomenda", !this.get("AtualizarVendaSobEncomenda"),{silent: false});
    
                this.set("CodigoTipoEntregaAnterior", data.CodigoTipoEntrega,setOptions);
                this.set("CodigoFilialRetiradaAnterior", data.CodigoFilialRetirada,setOptions);
                this.set("QuantidadeAnterior", data.Quantidade,setOptions);
            }

            this.set("AtualizarRemoto", true,setOptions);
        }

        const atualizarRedux = () => {

            store.dispatch(atualizarItemAction({
                identificador: data.Identificador,
                dados: {
                    ...data,
                    AtualizarRemoto: false,
                    PercentualDesconto: global.formatNumber(data.PercentualDesconto),
                    Atualizar: !(store.getState().orcamento.ItensOrcamento?.find?.(i => i.Identificador == data.Identificador)?.Atualizar ?? false)
                }
            }))

            if (data.VendaSobEncomenda &&
                (this.get("CodigoTipoEntregaAnterior") !== data.CodigoTipoEntrega ||
                    this.get("CodigoFilialRetiradaAnterior") !== data.CodigoFilialRetirada ||
                    this.get("QuantidadeAnterior") !== data.Quantidade)) {

                
                
                store.dispatch(atualizarItemAction({identificador: data.Identificador, 
                    dados: {
                        CodigoTipoEntregaAnterior: data.CodigoTipoEntrega,
                        CodigoFilialRetiradaAnterior: data.CodigoFilialRetirada, 
                        QuantidadeAnterior: data.Quantidade,
                        AtualizarVendaSobEncomenda: !((store.getState().orcamento).ItensOrcamento?.find?.(i => i.Identificador == data.Identificador)?.AtualizarVendaSobEncomenda ?? false)
                    }
                }))

                
            }

            store.dispatch(atualizarItemAction({identificador: data.Identificador, dados: {AtualizarRemoto: true}}))

        }

        if (ehParaAtualizarEstadoLegado) {
            atualizarEstadoLegado()
        }

        if (ehParaAtualizarRedux) {
            atualizarRedux()
        }

        if (ehParaAtualizarEstadoLegado) {
            this.set("Atualizar", !this.get("Atualizar"),{silent: false})
        }

    },

    descricaoProdutoAlterada: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var self = this;


        global.ajax({
            url: "/Orcamento/DefinirDescricaoProdutoForaEstoqueItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                descricao: this.get("DescricaoProduto")
            }),
            error: function () { global.unblockUI(); },
            success: function(data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }
                global.unblockUI();
            },

        });
    },

    atualizarRetorno: function(data) {

        if (!data) {
            return;
        }

        var arr = global.where(data.ItensOrcamento, { Identificador: this.get("Identificador") });

        var item = null;

        if (arr && arr.length > 0) {
            item = arr[0];
        }

        if (item) {
            this.atualizar(item, false);
        }

        if (this.orcamento) {
            this.orcamento.atualizar(data);
        }

    },

    idClienteCentroCustoAlterado: function(e){ // FNX-4253
        if (!this.get("AtualizarRemoto")) {
            global.unblockUI();
            return;
        }
        global.blockUI();
        this.set("IdClienteCentroCustoAnterior", this.previous("IdClienteCentroCusto"));
        var idCC = parseInt(this.get("IdClienteCentroCusto"));
        var self = this;
        global.ajax({
            url: "/Orcamento/DefinirIdCentroCustoItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                idCentroCusto: idCC
            }),
            error: function (data) { global.unblockUI(); },
            success: function (data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    if (item.IdClienteCentroCusto === 0)
                        $(".select2-container--open").remove();
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

                global.unblockUI();
            },

        });
    },
    
    //@Deprecated
    quantidadeAlterada: function (e) {
        if (!this.get("AtualizarRemoto")) {
            global.unblockUI();
            return;
        }
        global.blockUI();
        this.set("QuantidadeAnterior", this.previous("Quantidade"));
        store.dispatch(atualizarItemAction({identificador: this.get("Identificador"), dados: {QuantidadeAnterior: this.previous("Quantidade")}}))

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirQuantidadeItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                quantidade: this.get("Quantidade"),
                quantidadeSolicitada: this.get("QuantidadeSolicitada"), // FNX-1959
                quantidadeEstoque: this.get("QuantidadeEstoque"), // FNX-5556
            }),
            error: function(data) {global.unblockUI();},
            success: function(data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

                global.unblockUI();
            },

        });
    },

    //@Deprecated
    pedidoCompraAlterado: function (e) {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirPedidoCompraItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                pedidoCompra: this.get("PedidoCompra")
            }),
            error: function () {
                self.set("PedidoCompra", "");
                global.unblockUI();
            },
            success: function (data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

                global.unblockUI();
            },

        });
    },

    ordemItemAlterada: function (model) {

        var novoValor = model.get('OrdemItem');

        if (novoValor && this.orcamento) {

            var orcamento = this.orcamento.toJSON();
            var valorAnterior = model.get('OrdemItemAnterior');
            var itens = orcamento.ItensOrcamento;
            var index = model.get('Index');

            for (var i = 0; i < itens.length; i++) {

                if (itens[i].OrdemItem === novoValor && itens[i].Identificador !== model.get('Identificador')) {

                    if (novoValor > valorAnterior) {
                        itens[index].OrdemItem = valorAnterior + 0.3;
                        itens[index - 1].OrdemItem = novoValor + 0.3;

                    } else {
                        itens[i].OrdemItem = novoValor + 0.3;

                    }
                }
            }

            itens = orcamento.ItensOrcamento = _.sortBy(orcamento.ItensOrcamento, function (e) { return e.OrdemItem; });

            var ordem = 1;
            var flag = 0;
            _.filter(orcamento.ItensOrcamento, function (e, i) {

                e.Index = i + 1;
                e.selecionado = false;

                if (novoValor >= valorAnterior) {
                    e.OrdemItem = ordem++;

                } else if (global.getPrecision(e.OrdemItem) > 0 || flag > 0) {

                    if (flag === 0) {
                        e.OrdemItem = Math.trunc(e.OrdemItem) + 1;
                    } else {
                        e.OrdemItem = flag;
                    }

                    flag = e.OrdemItem + 1;

                    if (itens.length > 0 && (itens.length - 1) === i) {
                        e.OrdemItem = itens[i - 1].OrdemItem + 1;
                    }
                }
            });

            var itensOrdenados = _.sortBy(orcamento.ItensOrcamento, function (e) { return e.OrdemItem; });

            this.orcamento.OrdemAlterada = true;
            this.orcamento.OrdemGravada = false;
            this.orcamento.OrdemItemFoco = novoValor;
            this.orcamento.atualizarItens(itensOrdenados);
        }
    },

    //@Deprecated
    precoProdutoAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        if (!this.get("SimulandoDesconto") && this.get("PercentualBonificacao") > 0) {
            this.set("PercentualBonificacao", 0);
        }
        this.set("SimulandoDesconto", false);

        global.blockUI();
        var self = this;
        global.ajax({
            url: "/Orcamento/DefinirPrecoProdutoItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                precoProduto: this.get("PrecoProduto"),
                percentualBonificacao: this.get("PercentualBonificacao")
            }),
            error: function () { global.unblockUI(); },
            success: function(data) {     
                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    item.PrecoAlteradoManualmente = true;
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }
                global.unblockUI();
            },

        });

    },

    markUpItemAlterado: function () {

        if (!this.get("AtualizarRemoto")) {
            return;
        }
        this.set("SimulandoDesconto", false);
        global.blockUI();
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirMarkUpProdutoItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                markUpPretendido: this.get("percentualMarkUp")}),
            error: function () { global.unblockUI(); },
            success: function (data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }
                global.unblockUI();
            },

        });

    },
    
    despesasInclusasAlterado: function () {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDespesasInclusasItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                despesasInclusas: this.get("DespesasInclusas")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    //@Deprecated
    dataMarcadaAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirAdquirirQuantidadeTotalItemOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                adquirirQuantidadeTotal: this.get("AdquirirQuantidadeTotal")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    OfertaSeletivaAlterada: function () {
        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirOfertaSeletiva",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                ofertaSelecionada: this.get("OfertaSelecionada")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }
            },

        });
    },

    //@Deprecated
    tipoEntregaAlterado: function() {
        if (!this.get("AtualizarRemoto")) {
            return;
        }

        this.set("CodigoTipoEntregaAnterior", this.previous("CodigoTipoEntrega"));

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirTipoEntregaItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                codigoTipoEntrega: this.get("CodigoTipoEntrega")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (self.get("CodigoTipoEntregaAlteradoAcoes") && item.VendaSobEncomenda && self.get("VendaSobEncomenda") != item.VendaSobEncomenda)
                    global.showWarnMessage("Produto " + item.Codigo + " definido sob encomenda.");

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    dataPrevisaoEntregaAlterada: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDataPrevisaoEntregaItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                dataPrevisaoEntrega: this.get("DataPrevisaoEntrega")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);

                }

                self.orcamento.atualizarItens(data.ItensOrcamento);

            },

        });
    },

    dataMarcadaEntregaAlterada: function() {

        var dataMarcadaInserida = this.get("DataMarcadaEntrega")

        const possuiDataMarcadaEntrega = dataMarcadaInserida && global.validateDate(dataMarcadaInserida)
        this.set("PossuiDataMarcadaEntrega", possuiDataMarcadaEntrega)
        store.dispatch(atualizarItemAction({
            identificador: this.get("Identificador"),
            dados: {
                PossuiDataMarcadaEntrega: possuiDataMarcadaEntrega
            }
        }))

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDataMarcadaEntregaItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                dataMarcadaEntrega: this.get("DataMarcadaEntrega")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);

                }

                self.orcamento.atualizarItens(data.ItensOrcamento);

            },

        });

    },

    //@Deprecated
    turnoEntregaAlterado: function() {
        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirTurnoEntregaItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                turnoEntrega: this.get("TurnoEntrega")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                self.orcamento.atualizarItens(data.ItensOrcamento);

            },

        });

    },

    entregaPosteriorAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;
        var entregaPosteriorAnterior = this.get("EntregaPosterior")

        global.ajax({
            url: "/Orcamento/DefinirEntregaPosteriorItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                entregaPosterior: this.get("EntregaPosterior")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                    if (data.HasErrors) { /*Ficha 380799*/
                        item.EntregaPosterior = !entregaPosteriorAnterior;
                    }
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    desativaRegimeEspecialAlterado: function () {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDesativaRegimeEspecialItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                desativaRegimeEspecial: this.get("DesativaRegimeEspecial"),
                bloquearRegimeEspecial: this.get("BloquearRegimeEspecial"),
                desativaRegimeEspecialAntes: this.get("DesativaRegimeEspecialAntes")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    //@Deprecated
    vendaSobEncomendaAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirVendaSobEncomendaItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                vendaSobEncomenda: this.get("VendaSobEncomenda")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    substituirDataMarcadaDataPrevisaoEntregaItens: function () {

        if (!this.get("DataMarcadaEntrega")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/SubstituirDataMarcadaDataPrevisaoEntregaItens",
            type: "post",
            async: false,
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                dataMarcadaEntrega: this.get("DataMarcadaEntrega")
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },
        });

    },

    adquirirQuantidadeTotalAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirAdquirirQuantidadeTotalItemOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                adquirirQuantidadeTotal: this.get("AdquirirQuantidadeTotal")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    },

    adicionaPedidoCompraCliente: function() {
        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/AlterarPedidoCompraCliente",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                numPedidoCompraCliente: this.get("PedidoCompraCliente")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    definirOidModalidadeEntrega: function () {  // 402445
        if (!this.get("AtualizarRemoto")) {
            return;
        }

        //this.set("??", this.previous("??"));

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirOidModalidadeEntregaItemOrcamento",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                oidModalidadeEntregaItemOrcamento: this.get("OidModalidadeEntrega")
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }


                if (item) {
                    if (item.CodigoFilialRetirada === "")
                        $(".select2-container--open").remove();
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    definirIdPontoRetirada: function () {  // 402445

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        //this.set("??", this.previous("??"));

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirIdPontoRetiradaItemOrcamento",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                oidModalidadeEntregaItemOrcamento: this.get("OidModalidadeEntrega")
            },
            success: function (data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }


                if (item) {
                    if (item.CodigoFilialRetirada === "") 
                        $(".select2-container--open").remove(); 
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    //@Deprecated
    filialRetiradaAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        this.set("CodigoFilialRetiradaAnterior", this.previous("CodigoFilialRetirada"));

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirFilialRetiradaItemOrcamento",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                codigoFilialRetirada: this.get("CodigoFilialRetirada")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }


                if (item) {
                    if (item.CodigoFilialRetirada === "") // FNX-5270
                        $(".select2-container--open").remove(); // FNX-5270
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    filialTransferenciaAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirFilialTransferenciaItemOrcamento",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                codigoFilialTransferencia: this.get("CodigoFilialTransferencia")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    if (item.CodigoFilialTransferencia === "")// FNX-5270
                        $(".select2-container--open").remove(); // FNX-5270
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    //@Deprecated
    tipoFaturamentoAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirTipoFaturamentoItemOrcamento",
            blockUI: false,
            type: "post",
            data: {
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                tipoFaturamento: this.get("TipoFaturamento")
            },
            success: function(data) {

                if (!data) {
                    global.unblockUI();
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    if (item.CodigoTipoFaturamento === "")
                        $(".select2-container--open").remove(); // FNX-5270
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }
                global.unblockUI();
            },

        });
    },

    aliquotaIPIAlterada: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirAliquotaIPIItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                aliquota: this.get("AliquotaIPI")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item,);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });
    },

    valorIPIAlterado: function() {

        if (!this.get("AtualizarRemoto")) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirValorIPIItemOrcamento",
            blockUI: false,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.get("IdentificadorOrcamento"),
                identificador: this.get("Identificador"),
                valor: this.get("ValorIPI")
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var arr = global.where(data.ItensOrcamento, { Identificador: self.get("Identificador") });

                var item = null;

                if (arr && arr.length > 0) {
                    item = arr[0];
                }

                if (item) {
                    self.atualizar(item);
                }

                if (self.orcamento) {
                    self.orcamento.atualizar(data);
                }

            },

        });

    }

})


window.ItemOrcamento = ItemOrcamento

const ItensOrcamento = Backbone.Collection.extend({
    model: ItemOrcamento,

    obterTotais: function() {

        var totais = {
            Quantidade: 0,
            PrecoTotal: 0
        };

        if (this.length === 0) {
            return totais;
        }

        this.each(function(model) {
            totais.Quantidade += model.get("Quantidade");
            totais.PrecoTotal += model.get("ValorTotal");
        });

        return totais;

    }
});

window.ItensOrcamento = ItensOrcamento

export {ItemOrcamento,ItensOrcamento}